import checkURL from '@/helpers/checkURL'
import isEmpty from '@/helpers/isEmpty'
import forOwn from '@/helpers/forOwn'
import { Platform, PlatformOrigin } from '@/types/platform'

const internalDomains = new Set(['imedia.ru'])

forOwn(PlatformOrigin, (origin, platform) => {
  if (!checkURL(origin) || platform === Platform.im) {
    return
  }

  const domain = new URL(origin).hostname.split('.').slice(-2).join('.')

  internalDomains.add(domain)
})

export const checkInternalLink = (href?: string | null) => {
  if (isEmpty(href) || !checkURL(href)) {
    return false
  }

  const { hostname } = new URL(href)

  for (const internalDomain of internalDomains) {
    if (
      hostname === internalDomain ||
      hostname.endsWith(`.${internalDomain}`)
    ) {
      return true
    }
  }

  return false
}
